/*
 * Größenberater (CodeThat)
 * Größenscore = Konstante + Faktor BH-Umfang * Umfang + Faktor Körbchen * Körbchen (A=1 … F=6) + Aufschlag Körperform
 * Score 0 = XS, 1 = S, 2 = M, 3 = L, 4 = XL, 5 = XXL, 6 = XXXL, 7 = 4XL
 */
(function () {
  if (customElements.get('size-advisor')) return;

  var SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL'];
  var MAX_SCORE = SIZES.length - 1;
  var CODE_TO_SCORE = {
    XS: 0, S: 1, M: 2, L: 3, XL: 4,
    XXL: 5, '2XL': 5,
    XXXL: 6, '3XL': 6,
    XXXXL: 7, '4XL': 7
  };
  var STORAGE_KEY = 'herzlein-size-advisor';

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  // "36/38 (S)" → S, "S" → S, "36-38" → S, "36-40" → S bis M
  function parseSizeRange(label) {
    var text = String(label).toUpperCase();
    var inParens = text.match(/\(([^)]+)\)/);
    var code = (inParens ? inParens[1] : text).replace(/\s+/g, '');
    if (Object.prototype.hasOwnProperty.call(CODE_TO_SCORE, code)) {
      return { lo: CODE_TO_SCORE[code], hi: CODE_TO_SCORE[code] };
    }
    // Nur Doppelgrößen wie "36/38" oder Bereiche wie "36-40". Einzelgrößen ("38") lassen sich
    // nicht eindeutig S/M/L zuordnen und werden bewusst nicht beraten.
    if (!/\d{2}\s*[\/-]\s*\d{2}/.test(text)) return null;
    var numbers = (text.match(/\d{2}/g) || []).map(Number).filter(function (n) {
      return n >= 30 && n <= 66;
    });
    if (!numbers.length) return null;
    var lo = clamp(Math.floor((Math.min.apply(null, numbers) - 32) / 4), 0, MAX_SCORE);
    var hi = clamp(Math.floor((Math.max.apply(null, numbers) - 32) / 4), 0, MAX_SCORE);
    return { lo: lo, hi: hi };
  }

  function readStorage() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeStorage(values) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(values));
    } catch (e) {}
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function escapeValue(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/"/g, '\\"');
  }

  class SizeAdvisor extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      try {
        this.config = JSON.parse(this.querySelector('[data-size-advisor-config]').textContent);
      } catch (e) {
        this.hidden = true;
        return;
      }
      if (!isFinite(this.config.intercept) || !this.config.coefBand) {
        this.hidden = true;
        return;
      }

      this.entries = this.buildSizeEntries();
      if (!this.entries.length) {
        // Größen dieses Artikels lassen sich keinem Score zuordnen
        this.hidden = true;
        return;
      }
      this.minScore = Math.min.apply(null, this.entries.map(function (e) { return e.lo; }));
      this.maxScore = Math.max.apply(null, this.entries.map(function (e) { return e.hi; }));

      this.dialog = this.querySelector('dialog');
      this.elms = {
        band: this.querySelector('[data-size-advisor-input="band"]'),
        cup: this.querySelector('[data-size-advisor-input="cup"]'),
        shapes: this.querySelectorAll('[data-size-advisor-input="shape"]'),
        recSize: this.querySelector('[data-size-advisor-rec-size]'),
        recNote: this.querySelector('[data-size-advisor-rec-note]'),
        marker: this.querySelector('[data-size-advisor-marker]'),
        sizes: this.querySelector('[data-size-advisor-sizes]'),
        apply: this.querySelector('[data-size-advisor-apply]')
      };

      this.restoreInputs();
      this.bindEvents();
      this.update();
    }

    buildSizeEntries() {
      var index = this.config.sizeOptionIndex;
      var byValue = {};
      var entries = [];
      this.config.variants.forEach(function (variant) {
        var value = variant.options[index];
        if (value == null) return;
        var entry = byValue[value];
        if (!entry) {
          var range = parseSizeRange(value);
          if (!range) return;
          entry = byValue[value] = { value: value, lo: range.lo, hi: range.hi, available: false };
          entries.push(entry);
        }
        if (variant.available) entry.available = true;
      });
      return entries;
    }

    entryForScore(score) {
      return this.entries.find(function (e) { return e.lo <= score && score <= e.hi; }) || null;
    }

    restoreInputs() {
      var saved = readStorage();
      if (saved.band && this.elms.band.querySelector('option[value="' + saved.band + '"]')) {
        this.elms.band.value = saved.band;
      }
      if (saved.cup && this.elms.cup.querySelector('option[value="' + saved.cup + '"]')) {
        this.elms.cup.value = saved.cup;
      }
      var shapeInputs = Array.prototype.slice.call(this.elms.shapes);
      if (saved.shape && shapeInputs.some(function (input) { return input.value === saved.shape; })) {
        shapeInputs.forEach(function (input) { input.checked = input.value === saved.shape; });
      }
    }

    bindEvents() {
      var self = this;
      var trigger = this.querySelector('[data-size-advisor-open]');
      trigger.addEventListener('click', function () {
        self.open();
      });
      // Körperform-Bilder schon laden, sobald die Kundin den Link ansteuert
      ['pointerenter', 'touchstart', 'focus'].forEach(function (type) {
        trigger.addEventListener(type, function () { self.preloadImages(); }, { once: true, passive: true });
      });
      this.querySelector('[data-size-advisor-close]').addEventListener('click', function () {
        self.close();
      });
      // Klick auf den abgedunkelten Hintergrund schließt
      this.dialog.addEventListener('click', function (event) {
        if (event.target === self.dialog) self.close();
      });
      this.dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('size-advisor-open');
        trigger.focus({ preventScroll: true });
      });
      this.addEventListener('change', function (event) {
        if (!event.target.matches('[data-size-advisor-input]')) return;
        self.update();
        writeStorage(self.getInputs());
      });
      this.elms.apply.addEventListener('click', function () {
        if (self.applyValue && self.selectVariantValue(self.applyValue)) self.close();
      });
    }

    preloadImages() {
      this.querySelectorAll('.size-advisor__shape-img').forEach(function (img) {
        img.loading = 'eager';
      });
    }

    open() {
      this.preloadImages();
      this.update();
      document.documentElement.classList.add('size-advisor-open');
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    close() {
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
      document.documentElement.classList.remove('size-advisor-open');
    }

    getInputs() {
      var shape = 'equal';
      this.elms.shapes.forEach(function (input) { if (input.checked) shape = input.value; });
      return { band: Number(this.elms.band.value), cup: Number(this.elms.cup.value), shape: shape };
    }

    calculateScore(inputs) {
      var c = this.config;
      var offset = Number(c.offsets[inputs.shape]) || 0;
      return Number(c.intercept) + Number(c.coefBand) * inputs.band + Number(c.coefCup) * inputs.cup + offset;
    }

    update() {
      var score = clamp(this.calculateScore(this.getInputs()), 0, MAX_SCORE);
      // x,5 wird aufgerundet: im Zweifel die größere Größe
      var recScore = clamp(Math.floor(score + 0.5), 0, MAX_SCORE);
      var note = '';
      var recEntry = null;

      if (recScore < this.minScore) {
        recScore = this.minScore;
        recEntry = this.entryForScore(this.minScore);
        note = 'Kleiner gibt es diesen Artikel nicht. ' + SIZES[this.minScore] + ' sitzt bei dir etwas lockerer.';
      } else if (recScore > this.maxScore) {
        note = 'Diesen Artikel gibt es leider nicht in deiner Größe.';
      } else {
        recEntry = this.entryForScore(recScore);
        if (!recEntry) note = 'Diese Größe gibt es bei diesem Artikel leider nicht.';
      }

      if (recEntry && !recEntry.available) {
        note = (note ? note + ' ' : '') + 'Diese Größe ist leider gerade ausverkauft.';
      }

      this.elms.recSize.textContent = recEntry ? recEntry.value : SIZES[recScore];
      this.elms.recNote.textContent = note;
      this.elms.recNote.hidden = !note;

      this.applyValue = recEntry && recEntry.available ? recEntry.value : null;
      this.elms.apply.hidden = !this.applyValue;
      if (this.applyValue) this.elms.apply.textContent = 'Größe ' + this.applyValue + ' auswählen';

      this.renderScale(score, recScore);
    }

    // Zeigt drei Größen (Empfehlung in der Mitte, am Skalenrand verschoben) mit Herz-Marker
    renderScale(score, recScore) {
      var first = clamp(recScore - 1, 0, MAX_SCORE - 2);
      var fraction = clamp((score - first) / 2, 0, 1);
      this.elms.marker.style.left = (fraction * 100).toFixed(1) + '%';

      var html = '';
      [first, first + 1, first + 2].forEach(function (s) {
        var entry = this.entryForScore(s);
        var status = '';
        if (!entry) status = 'nicht erhältlich';
        else if (!entry.available) status = 'ausverkauft';
        else if (entry.lo !== entry.hi) status = escapeHtml(entry.value);
        html +=
          '<div class="size-advisor__size' +
          (s === recScore ? ' is-recommended' : '') +
          (!entry || !entry.available ? ' is-unavailable' : '') +
          '"><span class="size-advisor__size-code">' + SIZES[s] + '</span>' +
          (status ? '<span class="size-advisor__size-status">' + status + '</span>' : '') +
          '</div>';
      }, this);
      this.elms.sizes.innerHTML = html;
    }

    // Wählt die Größe in der Variantenauswahl (Globo Swatch oder Theme-Buttons/Dropdown)
    selectVariantValue(value) {
      var scope = this.closest('.shopify-section') || document;
      var escaped = escapeValue(value);
      var globoInput = scope.querySelector('.globo-swatch-list li[data-value="' + escaped + '"] input[type="radio"]');
      if (globoInput) {
        globoInput.click();
        return true;
      }
      var themeRadio = scope.querySelector('.js-variant-radio-item[value="' + escaped + '"]');
      if (themeRadio) {
        themeRadio.click();
        return true;
      }
      var selects = scope.querySelectorAll('select.js-variant-select-item');
      for (var i = 0; i < selects.length; i++) {
        var option = selects[i].querySelector('option[value="' + escaped + '"]');
        if (option) {
          selects[i].value = value;
          selects[i].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
      return false;
    }
  }

  customElements.define('size-advisor', SizeAdvisor);
})();
